import axios from 'axios';
import * as c from '../constants';
import { ErrorResponse } from '../components/Errors/ErrorApiCalls';
import { ErrorRequest } from '../components/Errors/ErrorApiCalls';
import { ErrorMessage } from '../components/Errors/ErrorApiCalls';


/////////////////////
//  Authentication
////////////////////


export async function login(data){
    try{
        let res = await axios.post(c.LOGIN, data);
        console.log('Login successful:', res.request.statusText)
        return res.data;
    }catch (err) {
        throw handler(err);
    }
}



export async function logout(data){
    try{
        let res = await axios.post(c.LOGOUT, data);

        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

export async function getuser(data){
    try{
        let res = await axios.get(c.USERDATA, data);

        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

export async function getpublicuser(data){
    try{
        let res = await axios.get(c.PUBLIC_USERDATA, data);

        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

export async function updatealluserdata(data){
    try{
        let res = await axios.put(c.UPDATE_ALLUSERDATA, data);

        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

export async function getAddonPurchased(sku){
    try{
        let res = await axios.get(`${c.ADDON_PURCHASED}/${sku}/purchased/`);

        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

/////////////////////
//  CVD
////////////////////

export async function fto(data){
    try{
                let res = await axios.get(c.FTO, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function leptin(data){
    try{
                let res = await axios.get(c.LEPTIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function mono(data){
    try{
                let res = await axios.get(c.MONO, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function struct(data){
    try{
                let res = await axios.get(c.STRUCT, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ras(data){
    try{
                let res = await axios.get(c.RAS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function hyp(data){
    try{
                let res = await axios.get(c.HYP, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function hypmono(data){
    try{
                let res = await axios.get(c.HYPMONO, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dt1(data){
    try{
                let res = await axios.get(c.DT1, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dt2(data){
    try{
                let res = await axios.get(c.DT2, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dia(data){
    try{
                let res = await axios.get(c.DIA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function fam(data){
    try{
                let res = await axios.get(c.FAM, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function lip(data){
    try{
                let res = await axios.get(c.LIP, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dis(data){
    try{
                let res = await axios.get(c.DIS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function cardio(data){
    try{
                let res = await axios.get(c.CARDIO, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function micro(data){
    try{
                let res = await axios.get(c.MICRO, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function gutheartaxis(data){
    try{
                let res = await axios.get(c.GUTHEARTAXIS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function drugstatins(data){
    try{
                let res = await axios.get(c.DRUGSTATINS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function guidestatins(data){
    try{
                let res = await axios.get(c.GUIDESTATINS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function drugrec(data){
    try{
                let res = await axios.get(c.DRUGREC, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function rosuvastatin(data){
    try{
                let res = await axios.get(c.ROSUVASTATIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function fluvastatin(data){
    try{
                let res = await axios.get(c.FLUVASTATIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function statin(data){
    try{
                let res = await axios.get(c.STATIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function clopidogrel(data){
    try{
                let res = await axios.get(c.CLOPIDOGREL, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function NSAID(data){
    try{
                let res = await axios.get(c.NSAID, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function phenytoin(data){
    try{
                let res = await axios.get(c.PHENYTOIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function abacavir(data){
    try{
                let res = await axios.get(c.ABACAVIR, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function acenocoumarol(data){
    try{
                let res = await axios.get(c.ACENOCOUMAROL, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function allopurinol(data){
    try{
                let res = await axios.get(c.ALLOPURINOL, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function amitriptyline(data){
    try{
                let res = await axios.get(c.AMITRIPTYLINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function aripiprazole(data){
    try{
                let res = await axios.get(c.ARIPIPRAZOLE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function atazanavir(data){
    try{
                let res = await axios.get(c.ATAZANAVIR, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function atomoxetine(data){
    try{
                let res = await axios.get(c.ATOMOXETINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function atorvastatin(data){
    try{
                let res = await axios.get(c.ATORVASTATIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function azathioprine(data){
    try{
                let res = await axios.get(c.AZATHIOPRINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function brexpiprazole(data){
    try{
                let res = await axios.get(c.BREXIPIPRAZOLE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function capecitabine(data){
    try{
                let res = await axios.get(c.CAPECITABINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function carbamazepine(data){
    try{
                let res = await axios.get(c.CARBAMAZEPINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function celecoxib(data){
    try{
                let res = await axios.get(c.CELECOXIB, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function citalopram(data){
    try{
                let res = await axios.get(c.CITALOPRAM, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function clomipramine(data){
    try{
                let res = await axios.get(c.CLOMIPRAMINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function codeine(data){
    try{
                let res = await axios.get(c.CODEINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dapsone(data){
    try{
                let res = await axios.get(c.DAPSONE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function desipramine(data){
    try{
                let res = await axios.get(c.DESIPRAMINE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function dexlansoprazole(data){
    try{
                let res = await axios.get(c.DEXLANSOPRAZOLE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function doxepin(data){
    try{
                let res = await axios.get(c.DOXEPIN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function efavirenz(data){
    try{
                let res = await axios.get(c.EFAVIRENZ, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function eliglustat(data){
    try{
                let res = await axios.get(c.ELIGLUSTAT, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function escitalopram(data){
    try{
                let res = await axios.get(c.ESCITALOPRAM, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}



export async function drugtypes(data){
    try{
                let res = await axios.get(c.DRUGTYPES, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function drugcpic(data){
    try{
                let res = await axios.get(c.DRUGCPIC, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function variantsfilter(data){
    try{
                let res = await axios.get(c.FILTER_VARIANTS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


/////////////////////
//  Genome Files
////////////////////


export async function gendata(data){
    try{
                let res = await axios.get(c.GENDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function genarchive(data){
    try{
                let res = await axios.get(c.GENARCHIVE, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function varpathogenic(data){
    try{
                let res = await axios.get(c.VARPATH, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

//export async function varhardpathogenic(data){
//    try{
//                let res = await axios.get(c.VARHARDPATH, data);
//                    return res.data;
//    }catch (e) {
//        throw handler(e)
//    }
//}

/////////////////////
//  Drugtype
////////////////////


export async function CYP1A2_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP1A2_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP1A2_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP1A2_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP1A2_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP1A2_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP2A6_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A6_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2A6_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A6_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2A6_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A6_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP2A13_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A13_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2A13_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A13_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2A13_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2A13_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP2B6_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2B6_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2B6_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2B6_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2B6_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2B6_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP2C8_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C8_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2C8_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C8_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2C8_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C8_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function CYP2C19_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C19_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2C19_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C19_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2C19_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2C19_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP2D6_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2D6_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2D6_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2D6_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP2D6_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP2D6_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP3A4_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A4_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP3A4_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A4_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP3A4_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A4_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP3A5_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A5_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP3A5_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A5_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP3A5_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP3A5_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function CYP4F2_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.CYP4F2_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP4F2_Func_ListFetch(data){
    try{
                let res = await axios.get(c.CYP4F2_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function CYP4F2_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.CYP4F2_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function DPYD_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.DPYD_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function DPYD_Func_ListFetch(data){
    try{
                let res = await axios.get(c.DPYD_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function DPYD_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.DPYD_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function NUDT15_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.NUDT15_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function NUDT15_Func_ListFetch(data){
    try{
                let res = await axios.get(c.NUDT15_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function NUDT15_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.NUDT15_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function SLCO1B1_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.SLCO1B1_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function SLCO1B1_Func_ListFetch(data){
    try{
                let res = await axios.get(c.SLCO1B1_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function SLCO1B1_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.SLCO1B1_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function HLAA_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.HLAA_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function HLAA_Func_ListFetch(data){
    try{
                let res = await axios.get(c.HLAA_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function HLAA_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.HLAA_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function HLAB_Genotypes_ListFetch(data){
    try{
                let res = await axios.get(c.HLAB_GENOTYPE_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function HLAB_Func_ListFetch(data){
    try{
                let res = await axios.get(c.HLAB_FUNC_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function HLAB_Metabolizer_ListFetch(data){
    try{
                let res = await axios.get(c.HLAB_METABOLIZER_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


/////////////////////
//  CANCER APP
////////////////////



export async function Breast_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Breast_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Brain_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Brain_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Reproductive_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Reproductive_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Bhn_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Head_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Digestion_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Digestion_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Urinary_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Urinary_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Lung_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Lung_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}
export async function Endocrine_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Endocrine_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Skin_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Skin_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Bone_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Bone_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Eye_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Eye_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function Blood_Variants_ListFetch(data){
    try{
                let res = await axios.get(c.Blood_DATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}











export async function basedata(data){
    try{
                let res = await axios.get(c.BASEDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function baseDataAdd(data){
    try{
                let res = await axios.put(c.BASEDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function weightdata(data){
    try{
                let res = await axios.get(c.WEIGHTDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function addweight(data){
    try{
                let res = await axios.post(c.WEIGHTDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function bloodgroupdata(data){
    try{
                let res = await axios.get(c.BLOODGROUPDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function persDataApi(data){
    try{
                let res = await axios.get(c.PERSDATA, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

/* Drugtype PGx */





export async function bloodListFetch(data){
    try{
                let res = await axios.get(c.BLOODLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function docUpload(data){
    try{
                let res = await axios.post(c.VACCSPASS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function bloodScanGet(data){
    try{
                let res = await axios.get(c.BLOODSCAN, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function labDocUpload(data){
    try{
                let res = await axios.post(c.LABDOCS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function labDocDownload(data){
    try{
                let res = await axios.get(c.LABDOCS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function xrayUpload(data){
    try{
                let res = await axios.post(c.XRAYDOCS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function xrayDownload(data){
    try{
                let res = await axios.get(c.XRAYDOCS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function thyroidDownload(data){
    try{
                let res = await axios.get(c.THYROIDDOCS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function vaccPassFetch(data){
    try{
                let res = await axios.get(c.VACCSPASS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vaccPassUpload(data){
    try{
                let res = await axios.post(c.VACCSPASS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vaccPassDownload(data){
    try{
                let res = await axios.get(c.VACCSPASS, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vaccListFetch(data){
    try{
                let res = await axios.get(c.VACCLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vaccCountFetch(data){
    try{
                let res = await axios.get(c.VACCCOUNT, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vaccsAdd(data){
    try{
                let res = await axios.post(c.VACCLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function bpListFetch(data){
    try{
                let res = await axios.get(c.BPLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function bpAverageFetch(data){
    try{
                let res = await axios.get(c.BPAVERAGES, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function bpAverageFetch2(data){
    try{
                let res = await axios.get(c.BPAVERAGES2, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function bpAdd(data){
    try{
                let res = await axios.post(c.BPLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ecgAdd(data){
    try{
                let res = await axios.post(c.ECGLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ecgUpload(data){
    try{
                let res = await axios.post(c.ECGPDF, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ecgUrlFetch(data){
    try{
                let res = await axios.get(c.ECGPDF, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ecgListFetch(data){
    try{
                let res = await axios.get(c.ECGLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ecgCountFetch(data){
    try{
                let res = await axios.get(c.ECGCOUNT, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function a1cFetch(data){
    try{
                let res = await axios.get(c.BLOODSUGAR_A1C, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function a1cPost(data){
    try{
                let res = await axios.post(c.BLOODSUGAR_A1C, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ldlFetch(data){
    try{
                let res = await axios.get(c.BLOODLIPIDS_LDL, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function ldlPost(data){
    try{
                let res = await axios.post(c.BLOODLIPIDS_LDL, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function vitFetch(data){
    try{
                let res = await axios.get(c.VIT, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function crpFetch(data){
    try{
                let res = await axios.get(c.CRP, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function varDiseaseListFetch(data){
    try{
                let res = await axios.get(c.VARIANTDISEASELIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function varNutriListFetch(data){
    try{
                let res = await axios.get(c.VARIANTNUTRIGENICLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function varFitnessListFetch(data){
    try{
                let res = await axios.get(c.VARIANTFITNESSLIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}

export async function varLifestyleListFetch(data){
    try{
                let res = await axios.get(c.VARIANTLIFESTYLELIST, data);
                    return res.data;
    }catch (e) {
        throw handler(e)
    }
}


export async function forgotPassword(data) {
    try {
        let res = await axios.post(c.FORGOT_PASSWORD, data);

        return res.data;
    } catch (e) {
        throw handler(e);
    }
}


export async function updateProfile(userId, data){
    try{
        const options = {
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            }
        };

        const form_data = new FormData();
        for ( let key in data )
            form_data.append(key, data[key]);

        let res = await axios.put(`${c.UPDATE_PROFILE}/${userId}`, form_data, options);
        return res.data;
    }catch (e) {
        throw handler(e);
    }
}

/////////////////////
//  Gift redemption
////////////////////

// Sent without Authorization: a stale Knox token in localStorage would make DRF answer 401 on this public endpoint.
export async function getGiftPreview(code){
    let res = await axios.get(`${c.GIFT_REDEEM}/${encodeURIComponent(code)}/`, { headers: { Authorization: false } });
    return res.data;
}

// Raw axios error is rethrown on purpose: the page needs response.status / response.data (see redeemErrors.js).
export async function redeemGift(code){
    let res = await axios.post(`${c.GIFT_REDEEM}/${encodeURIComponent(code)}/`);
    return res.data;
}

export function handler(err) {
    let error = err;
    let content
/*
    if (err.response && err.response.data.hasOwnProperty("message"))
        error = err.response.data;
        
    else if (!err.hasOwnProperty("message")) 
            error = err.toJSON()
*/

if (error.response) { content = <ErrorResponse /> }
else if (error.request) { content = <ErrorRequest /> }
else if (error.message) { content = <ErrorMessage /> }

 return (
    
        <div> { content } </div>
)}


/*This file will contain all of the following functions, which are needed to access the Authentication API endpoints.
---
register 
makes API request to register the user.
Accepts users data as parameter.
--
login
makes API request to login the user.
Accepts users data as parameter.
---
forgotPassword
makes API request to login the user.
Accepts users 'email' in an object as parameter.
---
updateProfile
makes API request to update users data.
Accepts userId and data as parameter.
Loops through the data passed to create a FormData object.
An axios options object is created with the content type set to "multipart/form-data" to allow for image upload.
*/